module.exports = __webpack_public_path__ + "static/img/comLogo.3c3cf2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/comLogo.png
// module id = 4LoH
// module chunks = 1